/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Group_Name_RequiredInputs */



/**
* | output |
* | --- |
* | "Group name is required." |
*
* @param {Team_Manager_Group_Name_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_group_name_required = /** @type {((inputs?: Team_Manager_Group_Name_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Group_Name_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le nom du groupe est requis.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Angabe des Gruppennamens ist erforderlich.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il nome del gruppo è obbligatorio.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Название группы обязательно для заполнения.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El nombre del grupo es obligatorio.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("组名称为必填项。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループ名は必須です。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह का नाम आवश्यक है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("É necessário nomear o grupo.")
	return /** @type {LocalizedString} */ ("Group name is required.")
});